import React, { Fragment } from "react"
import { withRouter } from "react-router"
import EstimateCardBilling from "../../../../../components/Billing/Admin/EstimateCardBilling/index"

const EstimatePage = props => {
  return (
    <Fragment>
      <EstimateCardBilling {...props} />
    </Fragment>
  )
}

export default withRouter(EstimatePage)
